import { render } from "./RoundedPillBadgesTwo.vue?vue&type=template&id=7a66a53a&ts=true"
import script from "./RoundedPillBadgesTwo.vue?vue&type=script&lang=ts"
export * from "./RoundedPillBadgesTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__